// @flow
import React from "react";
import styled from "styled-components";
import theme from "views/resources/theme";
import Icon, { Icons } from "react-hp-icons";
import type { InlineProps, WaitProps } from "./types";

const InlineWait = ({
	wait,
	size = 1,
	color = theme.colors.fg,
}: InlineProps & WaitProps) => (
	<Wrapper>
		<Icon type={Icons.clock} size={size + 0.5} color={"#096DD9"} />
		<span>
			{wait} min. de espera {wait > 1 ? "estimados" : "estimado"}
		</span>
	</Wrapper>
);

const Wrapper = styled.div`
	display: flex;
	color: #096dd9;
	//Avoid word break
	white-space: nowrap;

	font-size: 12px;
	span {
		padding: 1px 4px 0;
	}
`;

export default InlineWait;
